// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2uzEA","footer":"ModalUpdate_footer__jBuLB"};